var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"imprint-component"}},[_c('LandingHeaderBar',{staticClass:"white-header full-width-header"}),_c('div',{staticClass:"inner-main"},[_c('LandingImprint')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }